// Angular
import { Component, OnInit, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
// Rxjs
import { filter } from 'rxjs';
// Component
import { SearchPanelComponent } from '../quick-panels/search-panel/search-panel.component';
// Modules
import { TranslocoDirective } from '@jsverse/transloco';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-quick-search',
  templateUrl: './quick-search.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective],
})
export class QuickSearchComponent implements OnInit {
  // Private
  private readonly offcanvasService = inject(NgbOffcanvas);
  private router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  /**
   * On Init
   * @memberof QuickSearchComponent
   */
  ngOnInit(): void {
    // Close quick panel if route changed
    this.router.events.pipe(
      filter((e) => e instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe((event: any) => {
      this.offcanvasService.dismiss();
    });
  }

  /**
   * Open Quick Search Panel
   * @memberof QuickSearchComponent
   */
  openQuickSearchPanel(): void {
    this.offcanvasService.open(SearchPanelComponent, { position: 'end' });
  }
}
